"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EstateLeaseTemplatizeResultSchema = exports.EstateLeaseReviewResultSchema = exports.EstateLeaseDraftResultSchema = exports.EstateLawReviewResultSchema = exports.EstateLeaseJobRequestSchema = exports.EstateLeaseJobInputSchema = exports.ESTATE_LEASE_JOB_ACTIONS = exports.ESTATE_LEASE_JOB_KINDS = exports.disclaimerSha256 = exports.disclaimerText = exports.ESTATE_LEASE_DISCLAIMERS = void 0;
exports.sha256Hex = sha256Hex;
exports.canonicalJson = canonicalJson;
exports.leaseTermsSha256 = leaseTermsSha256;
exports.leaseGuarantorsSha256 = leaseGuarantorsSha256;
exports.isLeaseSignedForCurrentVersion = isLeaseSignedForCurrentVersion;
exports.splitLeaseSections = splitLeaseSections;
exports.joinLeaseSections = joinLeaseSections;
const zod_1 = require("zod");
const estate_1 = require("./estate");
// ── Versioned disclaimers (spec 2026-10-14 §4). The UI shows exactly this text; the server
// recomputes the SHA and refuses a mismatch. Change wording ⇒ bump `version`.
exports.ESTATE_LEASE_DISCLAIMERS = {
    ruby_lease_ai: {
        key: 'ruby_lease_ai', version: '2026-10-14', url: null,
        title: 'RubyTill disclaimer and terms: AI-generated lease',
        lines: [
            'I understand this lease was generated by AI (Ruby) and may contain errors, omissions or outdated law.',
            'I have had this lease reviewed by a licensed attorney in the state where the property is located.',
            'I accept the RubyTill terms: RubyTill is not a law firm, does not give legal advice, and is not liable for this lease or how I use it.',
        ],
    },
    own_lease: {
        key: 'own_lease', version: '2026-10-14', url: null,
        title: 'RubyTill disclaimer and terms: my own lease',
        lines: [
            'This lease is my own document. RubyTill did not write or review it.',
            'I accept the RubyTill terms: RubyTill is not a law firm, does not give legal advice, and is not liable for this lease or how I use it.',
        ],
    },
    ruby_policy: {
        key: 'ruby_policy', version: 'pending', url: null,
        title: 'Ruby policy',
        lines: ['I have read and accept the Ruby policy for AI-generated documents.'],
    },
};
const disclaimerText = (key) => {
    const d = exports.ESTATE_LEASE_DISCLAIMERS[key];
    return `${d.title}\n${d.lines.join('\n')}`;
};
exports.disclaimerText = disclaimerText;
const disclaimerSha256 = (key) => sha256Hex((0, exports.disclaimerText)(key));
exports.disclaimerSha256 = disclaimerSha256;
// ── Pure-TS SHA-256 (sync, UTF-8, same result in Node and the browser) ──
const K = new Uint32Array([
    0x428a2f98, 0x71374491, 0xb5c0fbcf, 0xe9b5dba5, 0x3956c25b, 0x59f111f1, 0x923f82a4, 0xab1c5ed5, 0xd807aa98, 0x12835b01, 0x243185be, 0x550c7dc3,
    0x72be5d74, 0x80deb1fe, 0x9bdc06a7, 0xc19bf174, 0xe49b69c1, 0xefbe4786, 0x0fc19dc6, 0x240ca1cc, 0x2de92c6f, 0x4a7484aa, 0x5cb0a9dc, 0x76f988da,
    0x983e5152, 0xa831c66d, 0xb00327c8, 0xbf597fc7, 0xc6e00bf3, 0xd5a79147, 0x06ca6351, 0x14292967, 0x27b70a85, 0x2e1b2138, 0x4d2c6dfc, 0x53380d13,
    0x650a7354, 0x766a0abb, 0x81c2c92e, 0x92722c85, 0xa2bfe8a1, 0xa81a664b, 0xc24b8b70, 0xc76c51a3, 0xd192e819, 0xd6990624, 0xf40e3585, 0x106aa070,
    0x19a4c116, 0x1e376c08, 0x2748774c, 0x34b0bcb5, 0x391c0cb3, 0x4ed8aa4a, 0x5b9cca4f, 0x682e6ff3, 0x748f82ee, 0x78a5636f, 0x84c87814, 0x8cc70208,
    0x90befffa, 0xa4506ceb, 0xbef9a3f7, 0xc67178f2,
]);
function utf8(s) {
    const out = [];
    for (let i = 0; i < s.length; i++) {
        let c = s.charCodeAt(i);
        if (c >= 0xd800 && c <= 0xdbff && i + 1 < s.length) {
            const d = s.charCodeAt(i + 1);
            if (d >= 0xdc00 && d <= 0xdfff) {
                c = 0x10000 + ((c - 0xd800) << 10) + (d - 0xdc00);
                i++;
            }
        }
        if (c < 0x80)
            out.push(c);
        else if (c < 0x800)
            out.push(0xc0 | (c >> 6), 0x80 | (c & 63));
        else if (c < 0x10000)
            out.push(0xe0 | (c >> 12), 0x80 | ((c >> 6) & 63), 0x80 | (c & 63));
        else
            out.push(0xf0 | (c >> 18), 0x80 | ((c >> 12) & 63), 0x80 | ((c >> 6) & 63), 0x80 | (c & 63));
    }
    return Uint8Array.from(out);
}
function sha256Hex(input) {
    const msg = utf8(input);
    const len = msg.length;
    const padded = new Uint8Array(((len + 9 + 63) >> 6) << 6);
    padded.set(msg);
    padded[len] = 0x80;
    const bitLen = len * 8;
    const dv = new DataView(padded.buffer);
    dv.setUint32(padded.length - 8, Math.floor(bitLen / 0x100000000));
    dv.setUint32(padded.length - 4, bitLen >>> 0);
    const H = new Uint32Array([0x6a09e667, 0xbb67ae85, 0x3c6ef372, 0xa54ff53a, 0x510e527f, 0x9b05688c, 0x1f83d9ab, 0x5be0cd19]);
    const W = new Uint32Array(64);
    const rotr = (x, n) => (x >>> n) | (x << (32 - n));
    for (let off = 0; off < padded.length; off += 64) {
        for (let i = 0; i < 16; i++)
            W[i] = dv.getUint32(off + i * 4);
        for (let i = 16; i < 64; i++) {
            const s0 = rotr(W[i - 15], 7) ^ rotr(W[i - 15], 18) ^ (W[i - 15] >>> 3);
            const s1 = rotr(W[i - 2], 17) ^ rotr(W[i - 2], 19) ^ (W[i - 2] >>> 10);
            W[i] = (W[i - 16] + s0 + W[i - 7] + s1) >>> 0;
        }
        let [a, b, c, d, e, f, g, h] = H;
        for (let i = 0; i < 64; i++) {
            const S1 = rotr(e, 6) ^ rotr(e, 11) ^ rotr(e, 25);
            const t1 = (h + S1 + ((e & f) ^ (~e & g)) + K[i] + W[i]) >>> 0;
            const S0 = rotr(a, 2) ^ rotr(a, 13) ^ rotr(a, 22);
            const t2 = (S0 + ((a & b) ^ (a & c) ^ (b & c))) >>> 0;
            h = g;
            g = f;
            f = e;
            e = (d + t1) >>> 0;
            d = c;
            c = b;
            b = a;
            a = (t1 + t2) >>> 0;
        }
        H[0] = (H[0] + a) >>> 0;
        H[1] = (H[1] + b) >>> 0;
        H[2] = (H[2] + c) >>> 0;
        H[3] = (H[3] + d) >>> 0;
        H[4] = (H[4] + e) >>> 0;
        H[5] = (H[5] + f) >>> 0;
        H[6] = (H[6] + g) >>> 0;
        H[7] = (H[7] + h) >>> 0;
    }
    return Array.from(H).map((x) => x.toString(16).padStart(8, '0')).join('');
}
/** Sorted-key JSON with undefined dropped -- the input to every hash here. */
function canonicalJson(v) {
    if (v === null || typeof v !== 'object')
        return JSON.stringify(v);
    if (Array.isArray(v))
        return `[${v.map((x) => (x === undefined ? 'null' : canonicalJson(x))).join(',')}]`;
    const o = v;
    return `{${Object.keys(o).filter((k) => o[k] !== undefined).sort().map((k) => `${JSON.stringify(k)}:${canonicalJson(o[k])}`).join(',')}}`;
}
/** Extras normalised to their schema defaults so a legacy row ({} / missing) hashes the same
 *  before and after a no-op PUT that fills the defaults. Unparseable extras hash raw. */
function normaliseExtras(extras) {
    try {
        return estate_1.EstateLeaseExtrasSchema.parse(extras ?? {});
    }
    catch {
        return extras ?? {};
    }
}
function leaseTermsSha256(l) {
    return sha256Hex(canonicalJson({
        unitId: l.unitId, residentIds: [...(l.residentIds ?? [])].sort(), startDate: l.startDate, endDate: l.endDate ?? null,
        dueDay: l.dueDay, rentCents: l.rentCents, depositCents: l.depositCents ?? 0, recurringCharges: l.recurringCharges ?? [],
        escalation: l.escalation ?? null, lateFee: l.lateFee ?? null, extras: normaliseExtras(l.extras),
    }));
}
/** Order-insensitive hash of a lease's guarantors (sorted by email, name trimmed, email lowercased). */
function leaseGuarantorsSha256(guarantors) {
    const list = (guarantors ?? []).map((g) => ({ name: String(g.name ?? '').trim(), email: String(g.email ?? '').trim().toLowerCase() }));
    list.sort((a, b) => (a.email < b.email ? -1 : a.email > b.email ? 1 : a.name < b.name ? -1 : a.name > b.name ? 1 : 0));
    return sha256Hex(canonicalJson(list));
}
/** The ONE definition of "signed for the current version": an executed packet for exactly the
 *  approved document version with the same guarantors it was sent with, or a signed-outside copy
 *  recorded for exactly the approved version. A packet with no guarantorsSha256 (sent before the
 *  hash existed) only matches a lease that has no guarantors. */
function isLeaseSignedForCurrentVersion(lease) {
    if (!lease)
        return false;
    const approved = lease.document?.approvedVersion;
    if (approved == null)
        return false;
    const sg = lease.signing;
    if (sg && sg.status === 'executed' && sg.version === approved) {
        const current = lease.guarantors ?? [];
        const ok = sg.guarantorsSha256 ? sg.guarantorsSha256 === leaseGuarantorsSha256(current) : current.length === 0;
        if (ok)
            return true;
    }
    const so = lease.signedOutside;
    return !!(so && so.docKey && so.version === approved);
}
// ── Ruby lease jobs (pos-agents-ext) ──
exports.ESTATE_LEASE_JOB_KINDS = ['law_review', 'lease_draft', 'lease_review', 'lease_templatize'];
exports.ESTATE_LEASE_JOB_ACTIONS = {
    law_review: 'text.lease_law_review', lease_draft: 'text.lease_draft', lease_review: 'text.lease_review',
    lease_templatize: 'text.lease_templatize',
};
const s = (max) => zod_1.z.string().trim().max(max);
/** What the page sends Ruby: the terms in plain form (dollars as cents), the address and the extras. */
exports.EstateLeaseJobInputSchema = zod_1.z.object({
    landlordName: s(200).default(''),
    residentNames: zod_1.z.array(s(160)).max(10).default([]),
    address: zod_1.z.object({ line1: s(200).default(''), line2: s(200).default(''), city: s(100).default(''), state: s(50).default(''), zip: s(20).default('') }),
    unitLabel: s(80).default(''),
    propertyKind: zod_1.z.enum(['residential', 'commercial', 'mixed']).default('residential'),
    startDate: s(10), endDate: s(10).optional(), dueDay: zod_1.z.number().int().min(1).max(31),
    rentCents: zod_1.z.number().int().min(0), depositCents: zod_1.z.number().int().min(0).default(0),
    lateFee: zod_1.z.object({ graceDays: zod_1.z.number().int(), type: zod_1.z.enum(['flat', 'percent']), amountCents: zod_1.z.number().int(), percentBps: zod_1.z.number().int() }),
    recurringCharges: zod_1.z.array(zod_1.z.object({ code: s(20), label: s(80), amountCents: zod_1.z.number().int() })).max(10).default([]),
    escalation: zod_1.z.object({ percentBps: zod_1.z.number().int(), month: zod_1.z.number().int() }).optional(),
    extras: zod_1.z.record(zod_1.z.unknown()).default({}),
    /** Law items the landlord kept, as "title: detail" lines (lease_draft only). */
    lawNotes: zod_1.z.array(s(500)).max(25).default([]),
    /** Final wave I4 (lease_templatize): more people values Ruby must turn into variables. */
    guarantorNames: zod_1.z.array(s(160)).max(5).optional(),
    residentEmails: zod_1.z.array(s(254)).max(10).optional(),
    landlordEmail: s(254).optional(),
});
exports.EstateLeaseJobRequestSchema = zod_1.z.object({
    kind: zod_1.z.enum(exports.ESTATE_LEASE_JOB_KINDS), leaseId: s(80).min(1), input: exports.EstateLeaseJobInputSchema,
    /** Required for lease_draft: the ruby_policy acceptance the page showed. */
    policy: zod_1.z.object({ version: s(40), sha256: zod_1.z.string().length(64) }).optional(),
    /** Required for lease_review: the version and body Ruby reviews section by section. */
    review: zod_1.z.object({ version: zod_1.z.number().int().min(1), body: zod_1.z.string().min(1).max(120000) }).optional(),
    /** Required for lease_templatize (2026-10-15): the approved lease version Ruby turns into a master template. */
    templatize: zod_1.z.object({ leaseId: s(80).min(1), version: zod_1.z.number().int().min(1), body: zod_1.z.string().min(1).max(120000) }).optional(),
}).superRefine((v, ctx) => {
    if (v.kind === 'lease_templatize' && !v.templatize) {
        ctx.addIssue({ code: zod_1.z.ZodIssueCode.custom, path: ['templatize'], message: 'templatize is required when kind is lease_templatize' });
    }
    if (v.kind === 'lease_review' && !v.review) {
        ctx.addIssue({ code: zod_1.z.ZodIssueCode.custom, path: ['review'], message: 'review is required when kind is lease_review' });
    }
});
exports.EstateLawReviewResultSchema = zod_1.z.object({
    items: zod_1.z.array(estate_1.EstateLawSuggestionSchema).max(25), sources: zod_1.z.array(estate_1.EstateLawSourceSchema).max(20),
});
exports.EstateLeaseDraftResultSchema = zod_1.z.object({ body: zod_1.z.string().min(200).max(120000) });
// ── Review-with-Ruby (spec 2026-10-15): the raw result Ruby returns for a lease_review job. ──
exports.EstateLeaseReviewResultSchema = zod_1.z.object({
    sections: zod_1.z.array(estate_1.EstateLeaseReviewSectionSchema).max(80),
    sources: zod_1.z.array(estate_1.EstateLawSourceSchema).max(20),
    summary: s(600),
});
/** lease_templatize result (2026-10-15): the body with parties/terms replaced by `{{variables}}`. */
exports.EstateLeaseTemplatizeResultSchema = zod_1.z.object({ body: zod_1.z.string().min(1).max(120000) });
/**
 * Split a lease body into sections on lines starting with `## `. Text before the first such
 * line (title/preamble) is section 0, whose heading is its first `# ` line or 'Preamble'.
 * Each section's `text` includes its own heading line. `joinLeaseSections(splitLeaseSections(x))
 * === x` for every `x`, byte for byte (trailing newlines, CRLF, and bodies with no `## ` at all).
 */
function splitLeaseSections(body) {
    // Split right after every newline, keeping the newline (and any preceding \r) attached to the
    // line it ends -- this partitions `body` losslessly, so re-joining every piece reproduces it exactly.
    const lineChunks = body === '' ? [] : body.split(/(?<=\n)/);
    const breakpoints = [];
    for (let i = 0; i < lineChunks.length; i++) {
        if (lineChunks[i].startsWith('## '))
            breakpoints.push(i);
    }
    const stripEol = (line) => line.replace(/\r?\n$/, '');
    const firstEnd = breakpoints.length > 0 ? breakpoints[0] : lineChunks.length;
    const preambleChunks = lineChunks.slice(0, firstEnd);
    let preambleHeading = 'Preamble';
    for (const line of preambleChunks) {
        if (line.startsWith('# ') && !line.startsWith('## ')) {
            preambleHeading = stripEol(line.slice(2));
            break;
        }
    }
    const sections = [
        { index: 0, heading: preambleHeading, text: preambleChunks.join('') },
    ];
    for (let b = 0; b < breakpoints.length; b++) {
        const start = breakpoints[b];
        const end = b + 1 < breakpoints.length ? breakpoints[b + 1] : lineChunks.length;
        const chunk = lineChunks.slice(start, end);
        sections.push({ index: b + 1, heading: stripEol(chunk[0].slice(3)), text: chunk.join('') });
    }
    return sections;
}
function joinLeaseSections(sections) {
    return sections.map((sec) => sec.text).join('');
}
//# sourceMappingURL=estateLease.js.map